import { gql } from '@apollo/client';

export const CREATE_ACCOUNT_CONTACT_RELATION = gql`
    mutation CreateAccountContactRelation($accountId: String!) {
        createAccountContactRelation(accountId: $accountId)
    }
`;
